import { render, staticRenderFns, recyclableRender, components } from "./course.vue?vue&type=template&id=5985334c&scoped=true&"
var renderjs
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=5985334c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985334c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/liveCourse/course.vue"
export default component.exports